interface IAnalysisResult {
    IsSuccess: boolean;
    GeoJson: string;
    Msg: string;
}


const analysisNames = {
    buffer: "buffer",
    tyson: "tyson",
    intersect: "intersect",
    union: "union",
    tin: "tin",
    convex: "convex"
}


const analysis =
    (oldLayerName: string,
        newLayerName: string,
        analysisName: string,
        options: any = null,
        callback: (result: IAnalysisResult) => void = null) => {
        
        (<any>window).DotNet.invokeMethodAsync("VGis", "Analysis",
            oldLayerName, newLayerName, analysisName, options)
            .then((result: IAnalysisResult) => {
                typeof callback === "function" && callback(result);
            });
    };

//alias for analysis
const analysis1 = analysis;

const analysis2 = (layerName1: string,
    layerName2: string,
    newLayerName: string,
    analysisName: string,
    options: any,
    callback: (result: IAnalysisResult) => void = null) => {
    (<any>window).DotNet.invokeMethodAsync("VGis", "Analysis2",
        layerName1, layerName2, newLayerName, analysisName, options)
        .then((result: IAnalysisResult) => {
            typeof callback === "function" && callback(result);
        });
}



export { analysis, analysis1, analysis2, analysisNames, IAnalysisResult } 